import React from 'react';
import { motion } from 'framer-motion';
import SectionShell from './Chapter';
import { SITE } from '@/constants/testIds';

const PILLARS = [
  {
    id: 'ib',
    n: '01',
    title: 'Investment Banking',
    lead:
      'Capital, structuring and placement for growth-stage and established businesses.',
    items: [
      'Growth and late-stage capital raises',
      'Private placements to strategic and financial investors',
      'Structured capital, mezzanine and hybrid instruments',
      'Pre-fundraise diagnostics and fund-readiness',
    ],
  },
  {
    id: 'mna',
    n: '02',
    title: 'Mergers & Acquisitions',
    lead:
      'Buy-side and sell-side execution — from origination through negotiated close.',
    items: [
      'Sell-side mandates for founder and family-owned businesses',
      'Buy-side origination, target evaluation and outreach',
      'Valuation, deal structuring and financial modelling',
      'Due-diligence coordination and negotiation support',
    ],
  },
  {
    id: 'strat',
    n: '03',
    title: 'Strategic Project Advisory',
    lead:
      'Feasibility, market entry and joint-venture work for large-scale initiatives.',
    items: [
      'Market entry and cross-border expansion strategy',
      'Feasibility studies and investment cases',
      'Joint-venture structuring and partner selection',
      'Execution roadmaps and board-level advisory',
    ],
  },
];

export const WhatWeDo = () => {
  const ease = [0.22, 1, 0.36, 1];
  return (
    <SectionShell
      id="what"
      testId={SITE.what}
      theme="dark"
      index="02"
      eyebrow="What we do"
      title={
        <>
          Three practices, one discipline: the transaction has to close on
          terms the client would defend.
        </>
      }
      intro="End-to-end capability across the deal and strategy lifecycle. Every mandate is scoped to a definable outcome — not a retainer that outlives its usefulness."
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-14">
        {PILLARS.map((p, i) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px' }}
            transition={{ duration: 0.75, delay: i * 0.08, ease }}
            className="relative pt-8 border-t border-[color:var(--rule-dark-2)]"
          >
            <div className="flex items-center justify-between small-caps text-[11px] text-[color:var(--stone-2)]">
              <span className="text-[color:var(--gold-2)]">{p.n}</span>
              <span>Practice</span>
            </div>
            <h3 className="mt-8 font-serif text-[28px] md:text-[32px] leading-[1.1] tracking-[-0.015em] text-[color:var(--stone)]">
              {p.title}
            </h3>
            <p className="mt-4 text-[15px] leading-[1.6] text-[color:var(--stone-2)]">
              {p.lead}
            </p>
            <ul className="mt-8 space-y-3">
              {p.items.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-3 text-[14px] leading-[1.55] text-[color:var(--stone)]"
                >
                  <span className="mt-[10px] block w-3 h-px bg-[color:var(--gold-2)] shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </SectionShell>
  );
};

export default WhatWeDo;
